var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarSharp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.283 12.568L360.171 181.641H537.793C555.397 181.641 562.716 204.187 548.474 214.543L404.775 319.036L459.663 488.109C465.103 504.866 445.941 518.8 431.699 508.444L288 403.951L144.301 508.444C130.059 518.8 110.897 504.866 116.337 488.109L171.225 319.036L27.526 214.543C13.284 204.187 20.603 181.641 38.207 181.641H215.829L270.717 12.568C276.157 -4.189 299.843 -4.189 305.283 12.568Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSharp);
export default __webpack_public_path__ + "static/media/star-sharp.b335fdfea40b212f137ddba2dd96db37.svg";
export { ForwardRef as ReactComponent };